module.exports = __webpack_public_path__ + "img/blueBin.700f5d49.svg";